/**
 * Used for handling various async methods
 * @param method
 * @return {(function(): Promise<void>)|*}
 */
export const useAsyncHandler = (method) => async () => {
    await (await method)()
};